import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import SurfaceCorrectionCard from "./components/cards/SurfaceCorrectionCard";
import NoiseReductionCard from "./components/cards/NoiseReductionCard";
import { useSelector } from "react-redux";
import PositionCard from "./components/cards/PositionCard";
import FocusByPercentageCard from "./components/cards/FocusByPercentageCard";
import NoiseReductionStepCard from "./components/cards/NoiseReductionStepCard";
import NoiseReductionScatterCard from "./components/cards/NoiseReductionScatterCard";
import { DataFilterTypes } from "./common/common";
import FocusCard from "./components/cards/FocusCard";
import FocusRemoveWorst from "./components/cards/FocusRemoveWorst";
import { cardTitleSx } from "./theme";

/**
 * Scan Analysis's right-rail cards: Positions, Surface Correction, and the active filters.
 *
 * The Apply / Apply & Save actions live in the separate CalculationActions component instead of
 * here, pinned to the bottom of the rail rather than scrolling with these cards - see
 * VisualizerContent.js's renderWithRightRail for why (rail content taller than the viewport
 * used to scroll the actions out of view entirely).
 */
export default function CalculationContainer(props)
{
    const calcSettings = useSelector(state => state.calcSettings);

    const renderFilter = (filter) => {
        switch(filter.type) {
            case DataFilterTypes.NoiseReduction:
                return (<NoiseReductionCard />);
            case DataFilterTypes.NoiseReductionStep:
                return (<NoiseReductionStepCard />);
            case DataFilterTypes.NoiseReductionScatter:
                return (<NoiseReductionScatterCard />);
            case DataFilterTypes.Focus:
                return (<FocusCard />);
            case DataFilterTypes.FocusByPercentage:
                return (<FocusByPercentageCard/> );
            case DataFilterTypes.FocusRemoveWorst:
                return (<FocusRemoveWorst />);
            default:
                return (<></>);
        }
    }

    const renderFilters = () => {
        console.log("dataFilters: ", calcSettings.changes.dataFilters);
        return (
            <>
                {calcSettings.changes.dataFilters.filter(df => df.preFilter === true).map((filter, index) => (
                    renderFilter(filter)
                ))}
                {calcSettings.changes.dataFilters.filter(df => df.preFilter !== true && df.enabled === true).map((filter, index) => (
                    renderFilter(filter)
                ))}
            </>
        )
    }

    return(
        <Box sx={{borderTop:"0px solid #999"}}>
            {/* Flat stack of independent cards, matching the mockup's rail - not one big card
                wrapping all of these, which read as a "double border" next to Raw Surface's rail. */}
            <Stack spacing={1.5}>
                <PositionCard />
                <SurfaceCorrectionCard />
                <Typography sx={cardTitleSx}>Filters</Typography>
                {renderFilters()}
            </Stack>
        </Box>
    )
}
